<template>
  <div class="">
    <div class="detailsTitle">
      <div class="detailsWrap"></div>
      <p>Wayne</p>
    </div>
    <el-form>
      <el-form-item :label="layout == 5 ? '投票标题 ：' : '日記名稱 ：'">
        <input
          v-if="layout != 5"
          maxlength="256"
          class="el-input__inner"
          type="text"
          v-model="data.diaryName"
        />
        <input
          v-else
          class="el-input__inner"
          type="text"
          v-model="data.diaryName"
          placeholder="請輸入投票标题（必填）"
        />
      </el-form-item>

      <el-form-item label="新聞版塊 ：">
        <el-select v-model="data.diaryType" disabled placeholder="">
          <el-option label="Wayne" value="1"></el-option>
        </el-select>
      </el-form-item>
      <!-- <el-form-item label="新聞類別 ：" v-if="type==='add'">
        <el-radio-group v-model="userLayout">
            <el-radio :label="1">VIP用戶</el-radio>
            <el-radio :label="2">僅測試人員</el-radio>
        </el-radio-group>
      </el-form-item> -->
      <!-- <el-form-item label="新聞類別 ：" v-else>
        <p class="blackColor" v-if="userLayout===1">VIP用戶</p>
        <p class="blackColor" v-else>僅測試人員</p>
      </el-form-item> -->
      <el-form-item label="發佈類型 ：">
        <el-radio-group v-model="layout" :disabled="JJstatus == 1">
          <el-radio :label="1">文字</el-radio>
          <el-radio :label="2">圖文</el-radio>
          <el-radio :label="3">視頻</el-radio>
          <el-radio :label="4">音頻</el-radio>
          <el-radio :label="5">投票</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="定時發佈:" v-if="status === 2">
        <el-switch
          active-color="#6C3DEA"
          v-model="timingFlag"
          @change="changeTimingFlag"
        >
        </el-switch>
      </el-form-item>

      <el-form-item v-show="timingFlag" label="發佈時間:">
        <el-date-picker
          v-model="publishTime"
          type="datetime"
          placeholder="選擇時間"
          format="yyyy-MM-dd HH:mm"
          :picker-options="timeAfter"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="投票描述 ：" v-if="layout == 5">
        <el-input
          type="textarea"
          placeholder="請輸入投票描述（選填）"
          style="width: 300px;"
          resize="none"
          maxlength="500"
          v-model="voteContent"
        />
      </el-form-item>
      <el-form-item label="選項設置 ：" v-if="layout == 5">
        <div
          v-for="(item, index) in voteList"
          :key="index"
          style="margin-bottom: 10px;display: flex;align-items: center;"
        >
          <el-input
            :placeholder="`請輸入第${index + 1}項（50字以内）`"
            resize="none"
            maxlength="50"
            :disabled="JJstatus == 1"
            v-model="item.name"
            style="width: 300px;"
          />
          <i
            class="el-icon-circle-close"
            style="cursor: pointer;font-size: 20px;"
            @click="delVote(index)"
            v-if="index == voteList.length - 1 && index != 0 && JJstatus != 1"
          ></i>
        </div>
        <el-button
          type="primary"
          @click="addVote"
          v-if="voteList.length < 10 && JJstatus != 1"
          >添加</el-button
        >
      </el-form-item>
      <el-form-item
        v-show="layout === 3"
        label="上傳封面 :"
        class="titlePagePicupload"
      >
        <el-upload
          action=""
          :http-request="uploadRequest"
          :with-credentials="true"
          :headers="{ Authorization: this.$cookie.get('auth') }"
          :on-error="$errorImage"
          :on-exceed="$handleExceed.bind(this, 1)"
          :on-remove="titleHandleRemove"
          :file-list="titlePictureUrl"
          :on-progress="uploadImgProcess"
          :before-upload="beforePicUpload"
          :limit="1"
          accept=".jpg,.jpeg,.png,.tif,.tiff"
          :multiple="false"
          name="titlePage"
          list-type="picture-card"
        >
          <el-button v-if="!imgFlag" size="small" type="primary"
            >選擇圖片</el-button
          >
          <div slot="tip" class="el-upload__tip">支持jpg/png/tif格式</div>
          <el-progress
            v-if="imgFlag"
            type="circle"
            :percentage="imgUploadPercent"
            style="margin-top:10px;"
          ></el-progress>
        </el-upload>
      </el-form-item>

      <el-form-item label="上傳影片 :" v-show="layout === 3">
        <video
          width="80%"
          v-if="VideoUrl.length == 1"
          class="avatar"
          :src="VideoUrl[0].url"
          controls="controls"
        >
          您的浏览器不支持视频播放
        </video>
        <span @click="handleVideoRemove()" v-if="VideoUrl.length == 1"
          >刪除</span
        >
        <el-upload
          action=""
          :http-request="uploadRequest"
          :with-credentials="true"
          :headers="{ Authorization: this.$cookie.get('auth') }"
          :on-error="errorVideo"
          :on-exceed="handleVideoExceed"
          :on-remove="handleVideoRemove"
          :on-progress="uploadVideoProcess"
          :file-list="VideoUrl"
          :show-file-list="false"
          :before-upload="beforeVideoUpload"
          :limit="1"
          accept=".mp4"
          :multiple="false"
          name="vedio"
          list-type="picture-card"
        >
          <el-button v-if="!videoFlag" size="small" type="primary"
            >選擇視頻</el-button
          >
          <div slot="tip" class="el-upload__tip">支持mp4格式</div>
          <el-progress
            v-if="videoFlag"
            type="circle"
            :percentage="videoUploadPercent"
            style="margin-top:10px;"
          ></el-progress>
        </el-upload>
      </el-form-item>

      <el-form-item v-show="layout === 2" label="上傳主圖 ：" class="picupload">
        <el-upload
          action=""
          :http-request="uploadRequest"
          :with-credentials="true"
          :headers="{ Authorization: this.$cookie.get('auth') }"
          :on-error="$errorImage"
          :on-remove="handleRemove"
          :file-list="mainPictureUrl"
          :on-progress="uploadImgProcess"
          :before-upload="beforePicUpload"
          :limit="6"
          accept=".jpg,.jpeg,.png,.tif,.tiff"
          :multiple="false"
          name="mainPic"
          list-type="picture-card"
        >
          <el-button size="small" type="primary">選擇圖片</el-button>
          <div slot="tip" class="el-upload__tip">支持jpg/png/tif格式</div>
          <!--<el-progress v-if="imgFlag" type="circle" :percentage="imgUploadPercent"-->
          <!--             style="margin-top:10px;"></el-progress>-->
        </el-upload>
      </el-form-item>
      <!-- 上传音频 -->
      <el-form-item v-show="layout === 4" label="上傳音頻 ：" class="picupload">
        <el-upload
          action=""
          :http-request="uploadRequest"
          :with-credentials="true"
          :headers="{ Authorization: this.$cookie.get('auth') }"
          :on-error="$errorImage"
          :on-exceed="audiohandleExceed"
          :on-remove="handleAudioRemove"
          :file-list="audioFile"
          :before-upload="beforePicUpload"
          :limit="1"
          accept=".mp3, .mp4"
          :multiple="false"
          name="audio"
        >
          <el-button size="small" type="primary">選擇音頻文件</el-button>
          <div slot="tip" class="el-upload__tip">支持mp3、mp4格式</div>
        </el-upload>
      </el-form-item>
      <div class="editor-wrap" v-show="layout != 5">
        <p class="editor-title normal_font" style="width:1.3rem;">
          文字內容 ：
        </p>
        <Editor
          class="editor"
          style="color:#fff;"
          @listenContent="getContent"
          :colorFlag="true"
          :content="content"
          :newsFlag="true"
        ></Editor>
      </div>
    </el-form>
    <div class="bottomBtn mobileBtn">
      <div
        class="btn"
        style="color: #000000;background-color: #fff;border: 1px solid #000000;"
        @click="$router.go(-1)"
      >
        取消
      </div>
      <div class="btn new_btn" @click="addDiary()">發佈</div>
    </div>

    <DiaMess v-if="dialogVisible"></DiaMess>
  </div>
</template>

<script>
import Editor from "@/components/editor";
import fileUtils from "@/utils/fileUtils.js";
import DiaMess from "@/components/dialog";

export default {
  props: ["type", "id"],

  data() {
    return {
      mainPictureUrl: [], // 主图
      titlePictureUrl: [], // 封面
      VideoUrl: [], // 视频类型的video
      audioFile: [], // 音频文件list
      videoCdnFlag: true,
      cdnText: "預熱",
      data: {
        diaryName: "",
        diaryType: "1"
      },
      content: "",
      voteContent: "",
      mainImage: "",
      newsTitle: "",
      releaseTime: "",
      require: true, // 禁止用户连续点击，发出多次请求接口
      layout: 1,
      userLayout: 1,
      originalPublishTime: "", //发布时间
      originalVideoUrl: "", //原始视频URL
      pushTaskId: "",
      audioDuration: "", //音頻時長
      videoFlag: false,
      videoUploadPercent: 0,
      imgFlag: false,
      imgUploadPercent: 0,
      dialogVisible: false,
      timingFlag: false,
      publishTime: "",
      status: 2,
      voteList: [{ name: "" }],
      vote: "",
      JJstatus: ""
    };
  },
  created() {
    if (this.type === "edit") {
      this.getDetail();
    }
  },
  destroyed() {
    this.$message.closeAll();
  },
  methods: {
    //添加投票选项
    addVote() {
      this.voteList.push({ name: "" });
    },
    delVote(index) {
      this.voteList.splice(index, 1);
    },
    getDetail() {
      this.$get(
        `/request/diary/getDiaryDetail/${this.id}`,
        this.$GLOBAL.jsonConfig
      ).then(res => {
        if (res.code === "00000") {
          this.JJstatus = res.data.status;
          // switch (res.data.diaryType) {
          //   case '文字':
          //     this.layout = 1
          //     break
          //   case '圖片':
          //     this.layout = 2
          //     break
          //   case '視頻':
          //     this.layout = 3
          //     break
          //   case '音頻':
          //     this.layout = 4
          //     break
          // }
          this.layout = Number(res.data.diaryType);
          // 利用vlogUrl和primaryPictureUrl进行JJ日记类型的判断
          // if(res.data.primaryPictureUrl == '' && res.data.vlogUrl == '' && res.data.audioUrl == ''){
          //   this.layout = 1
          // }

          // if(res.data.primaryPictureUrl != '' && res.data.vlogUrl == '' && res.data.audioUrl == ''){
          //   this.layout = 2
          // }

          // if(res.data.primaryPictureUrl != '' && res.data.vlogUrl != '' && res.data.audioUrl == ''){
          //   this.layout = 3
          //   this.originalVideoUrl = res.data.vlogUrl
          // }
          // if(res.data.primaryPictureUrl == '' && res.data.vlogUrl == '' && res.data.audioUrl != ''){
          //   this.layout = 4
          // }
          this.originalPublishTime = res.data.publishDate; //原始发布时间
          this.content = res.data.context;
          this.data.diaryName = res.data.title;
          this.status = res.data.status;
          this.publishTime = new Date(res.data.publishDate);
          this.timingFlag = res.data.status === 2;

          // this.userLayout = res.data.oriType
          if (this.layout == 2) {
            // 图文
            let _this = this;
            if (res.data.autodyneUrls.length !== 0) {
              res.data.autodyneUrls.forEach(function(item) {
                _this.mainPictureUrl.push({ url: item });
              });
            } else {
              this.mainPictureUrl.push({ url: res.data.primaryPictureUrl });
            }

            if (this.mainPictureUrl.length === 6) {
              document.getElementsByClassName("el-upload")[2].style.display =
                "none";
            }
          } else if (this.layout == 3) {
            // 视频
            document.getElementsByClassName("el-upload")[0].style.display =
              "none";
            document.getElementsByClassName("el-upload")[1].style.display =
              "none";

            this.titlePictureUrl.push({ url: res.data.primaryPictureUrl });
            this.VideoUrl.push({ name: "video.mp4", url: res.data.vlogUrl });
          } else if (this.layout == 4) {
            // 音频
            document.getElementsByClassName("el-upload")[3].style.display =
              "none";
            this.audioFile.push({ name: "audio.mp3 ", url: res.data.audioUrl });
            this.audioDuration = res.data.audioDuration;
          } else if (this.layout == 5) {
            this.voteList = res.data.voteList;
            this.voteContent = res.data.context.replace(/<\/?p>/g, "");
          }
        } else {
          this.$propMessage(res.message, "error");
        }
      });
    },
    changeTimingFlag() {
      this.publishTime = "";
    },
    // 主图上传成功的回调函数
    successImage(res, file) {
      this.mainPictureUrl.push({ url: res.msg }); // 展示图片
      document.getElementsByClassName("el-upload")[2].style.display = "none";
    },
    // 封面图片上传成功回调函数
    titleSuccessImage(res, file) {
      this.titlePictureUrl.push({ url: res.msg });
      document.getElementsByClassName("el-upload")[0].style.display = "none";
    },
    // 图片上传之前的回调函数
    beforePicUpload(file) {
      let _this = this;
      return new Promise((resolve, reject) => {
        if (file.type === "image/tiff" || file.type === "audio/mpeg") {
          if (file.type === "audio/mpeg") {
            var content = file;
            //获取录音时长
            var url = URL.createObjectURL(content);
            //经测试，发现audio也可获取视频的时长
            var audioElement = new Audio(url);
            audioElement.addEventListener("loadedmetadata", _event => {
              if (parseInt(audioElement.duration) > 120) {
                _this.dialogVisible = true;
                _this.$propMessage(
                  "請上傳不超過2分鐘時長的音頻",
                  "error",
                  function() {
                    _this.dialogVisible = false;
                  }
                );
                reject();
              } else {
                let time = parseInt(audioElement.duration);
                let minuteTime = parseInt(time / 60);
                let secondTime = parseInt(time % 60);
                _this.audioDuration =
                  "0" +
                  minuteTime +
                  ":" +
                  (secondTime < 10 ? "0" + secondTime : secondTime);
                // console.log(_this.audioDuration)
                // console.log(file)
                resolve(file);
              }
            });
          } else if (file.type === "image/tiff") {
            resolve(file);
          }
        } else {
          fileUtils.getOrientation(file).then(orient => {
            if (orient && orient === 6) {
              let reader = new FileReader();
              let img = new Image();
              reader.onload = e => {
                img.src = e.target.result;
                img.onload = function() {
                  if (img.height > 3000 || file.size > 1024 * 1024 * 2) {
                    _this.$imageConversion
                      .compress(file, {
                        quality: 0.3,
                        height: 3000
                      })
                      .then(res => {
                        const data = fileUtils.rotateImage(
                          img,
                          img.width,
                          img.height
                        );
                        const newFile = fileUtils.dataURLtoFile(
                          data,
                          file.name
                        );
                        resolve(newFile);
                      });
                  } else {
                    const data = fileUtils.rotateImage(
                      img,
                      img.width,
                      img.height
                    );
                    const newFile = fileUtils.dataURLtoFile(data, file.name);
                    resolve(newFile);
                  }
                };
              };
              reader.readAsDataURL(file);
            } else {
              console.log(file); // image/tiff
              let _URL = window.URL || window.webkitURL;
              let img = new Image();
              img.onload = function() {
                if (img.width > 3000 || file.size > 1024 * 1024 * 2) {
                  _this.$imageConversion
                    .compress(file, {
                      quality: 0.3,
                      width: 3000
                    })
                    .then(res => {
                      resolve(res);
                    });
                } else {
                  resolve(file);
                }
              };
              img.src = _URL.createObjectURL(file);
            }
          });
        }
      });
    },
    // 主图移除图片的回调函数
    handleRemove(file) {
      this.imgFlag = false;
      this.$deleteUidItem(file.uid, this.mainPictureUrl);
      this.$Mint.Toast({ message: "刪除成功" });
      document.getElementsByClassName("el-upload")[2].style.display =
        "inline-block";
      return false;
    },
    // 封面图移除图片的回调函数
    titleHandleRemove(file) {
      this.imgFlag = false;
      this.$deleteUidItem(file.uid, this.titlePictureUrl);
      this.$Mint.Toast({ message: "刪除成功" });
      document.getElementsByClassName("el-upload")[0].style.display =
        "inline-block";
      return false;
    },
    // 移除音频
    handleAudioRemove(file) {
      this.$deleteUidItem(file.uid, this.audioFile);
      this.$Mint.Toast({ message: "刪除成功" });
      document.getElementsByClassName("el-upload")[3].style.display =
        "inline-block";
      return false;
    },
    // 上传视频
    uploadRequest(option) {
      console.log(option);
      // console.log('lll')
      const file = option.file;
      const self = this;
      return new Promise((resolve, reject) => {
        const date = self.$dateFormat(new Date(), "yyyy-MM-dd"); // 当前时间
        const dateTime = self.$dateFormat(new Date(), "yyyyMMddhhmmss"); // 当前时间
        let randomStr = self.$randomString(4); //  4位随机字符串
        const extensionName = file.name.substr(file.name.indexOf(".")); // 文件扩展名
        let fileWay = "";
        if (
          extensionName === ".mp4" ||
          extensionName === ".MP4" ||
          extensionName === ".Mp4" ||
          extensionName === ".mP4"
        ) {
          fileWay = "resource/video/";
        } else if (extensionName === ".mp3") {
          fileWay = "resource/audio/";
          console.log(fileWay);
        } else {
          fileWay = "resource/image/";
        }
        const fileName =
          fileWay + date + "/" + dateTime + "_" + randomStr + extensionName; // 文件名字（相对于根目录的路径 + 文件名）
        // 执行上传
        self.$createOssClient().then(client => {
          // 异步上传,返回数据
          // resolve({
          //   fileName: file.name,
          //   fileUrl: fileName // 图片路径
          // })
          // 上传处理
          // 分片上传文件
          client
            .multipartUpload(fileName, file, {
              progress: function(p) {
                if (
                  extensionName === ".mp4" ||
                  extensionName === ".MP4" ||
                  extensionName === ".Mp4" ||
                  extensionName === ".mP4"
                ) {
                  if (p > 0) {
                    self.videoFlag = true;
                  } else if ((p = 1)) {
                    self.videoFlag = false;
                  }
                  self.videoUploadPercent = Math.floor(p * 100);
                } else {
                  if (p > 0) {
                    self.imgFlag = true;
                  } else if ((p = 1)) {
                    self.imgFlag = false;
                  }
                  self.imgUploadPercent = Math.floor(p * 100);
                }
              },
              headers: { "Cache-Control": "public" }
            })
            .then(
              val => {
                if (val.res.statusCode === 200) {
                  if (option.filename === "vedio") {
                    self.VideoUrl.push({
                      name: "video.mp4",
                      url: self.$GLOBAL.picFileUrl + val.name
                    });
                    console.log(self.VideoUrl[0].url);
                    // cdn预热
                    // self.$cdnFun(self.VideoUrl[0].url).then(res=>{
                    //   this.pushTaskId=res.data.pushTaskId
                    // })
                    self.$convertVideo(val.name).then(res => {
                      console.log(res);
                    });
                    document.getElementsByClassName(
                      "el-upload"
                    )[1].style.display = "none";
                  } else if (option.filename === "titlePage") {
                    self.titlePictureUrl.push({
                      name: "image.jpeg",
                      url:
                        self.$GLOBAL.picFileUrl + val.name + self.$GLOBAL.xwPic
                    });
                    //cdn预热
                    self.$cdnFun(self.titlePictureUrl[0].url).then(res => {
                      console.log(res);
                    });
                    document.getElementsByClassName(
                      "el-upload"
                    )[0].style.display = "none";
                  } else if (option.filename === "mainPic") {
                    self.mainPictureUrl.push({
                      name: "image.jpeg",
                      url:
                        self.$GLOBAL.picFileUrl + val.name + self.$GLOBAL.xwPic
                    }); // 展示图片
                    //cdn预热
                    self.$cdnFun(self.mainPictureUrl[0].url).then(res => {
                      console.log(res);
                    });
                    if (this.mainPictureUrl.length === 6) {
                      document.getElementsByClassName(
                        "el-upload"
                      )[2].style.display = "none";
                    }
                  } else if (option.filename === "audio") {
                    self.audioFile.push({
                      name: file.name,
                      url: self.$GLOBAL.picFileUrl + val.name
                    }); // 展示图片

                    //cdn预热
                    self.$cdnFun(self.audioFile[0].url).then(res => {
                      console.log(res);
                    });

                    document.getElementsByClassName(
                      "el-upload"
                    )[3].style.display = "none";
                  }
                  return val;
                } else {
                  option.onError("上传失败");
                }
              },
              err => {
                console.log(err);
                option.onError("上传失败");
                reject(err);
              }
            );
        });
      });
    },
    errorVideo(data) {
      this.$propMessage(data, "error");
    },
    handleVideoExceed() {
      let _this = this;
      _this.dialogVisible = true;
      _this.$propMessage("最多上傳一個視頻", "error", function() {
        _this.dialogVisible = false;
      });

      return false;
    },
    audiohandleExceed() {
      let _this = this;
      _this.dialogVisible = true;
      _this.$propMessage("最多上傳一條音頻", "error", function() {
        _this.dialogVisible = false;
      });
      return false;
    },
    beforeVideoUpload(file) {
      let _this = this;
      // const isVideo = file.type === 'video/mp4' || 'video/3gp' || 'video/3gpp' || 'video/rm' || 'video/rmvb' || 'video/avi' || 'video/wmv' || 'video/mov';
      const isVideo = file.type === "video/mp4";
      // const isLt200M = file.size / 1024 / 1024 < 2048;
      if (!isVideo) {
        _this.dialogVisible = true;
        _this.$propMessage("上傳視頻格式不正確", "error", function() {
          _this.dialogVisible = false;
        });
        return false;
      }

      // if (!isLt200M) {
      //   this.$Mint.Toast('上傳視頻大小不能超過2GB!');
      //   return false;
      // };
    },
    handleVideoRemove(file) {
      this.VideoUrl = [];
      this.videoFlag = false;

      this.$Mint.Toast({ message: "刪除成功" });
      document.getElementsByClassName("el-upload")[1].style.display =
        "inline-block";
      return false;
    },
    // 视频进度条
    uploadVideoProcess(event, file, fileList) {
      this.videoFlag = true;
      this.videoUploadPercent = Number(file.percentage.toFixed(0));
    },
    // 主图进度条
    uploadImgProcess(event, file, fileList) {
      this.imgFlag = true;
      this.imgUploadPercent = Number(file.percentage.toFixed(0));
    },
    // 添加JJ日记
    addDiary() {
      let _this = this;
      if (_this.data.diaryName === "" || _this.data.diaryName.match(/^\s+$/)) {
        _this.dialogVisible = true;
        _this.$propMessage(
          _this.layout == "5" ? "請輸入投票標題" : "請輸入日記名稱",
          "error",
          function() {
            _this.dialogVisible = false;
          }
        );

        return false;
      }

      if (_this.$getCaption(_this.data.diaryName)) {
        _this.dialogVisible = true;
        _this.$propMessage("日記名稱不能含有非法字符", "error", function() {
          _this.dialogVisible = false;
        });
        return false;
      }

      if (this.status === 2 && this.timingFlag && !this.publishTime) {
        _this.dialogVisible = true;
        _this.$propMessage("請選擇發佈時間", "error", function() {
          _this.dialogVisible = false;
        });
        return false;
      } else if (this.status === 2 && this.timingFlag && this.publishTime) {
        let time = new Date(this.publishTime).getTime();
        let now = new Date().getTime();
        if (time < now) {
          this.dialogVisible = true;
          this.$propMessage("請選擇大於當前時間", "error", () => {
            this.dialogVisible = false;
            this.publishTime = "";
          });
          return;
        }
      }

      if (_this.layout == 2) {
        if (_this.mainPictureUrl.length === 0) {
          _this.dialogVisible = true;
          _this.$propMessage("請選擇主圖", "error", function() {
            _this.dialogVisible = false;
          });
          return false;
        }
      }

      if (_this.layout == 3) {
        if (_this.titlePictureUrl.length === 0) {
          _this.dialogVisible = true;
          _this.$propMessage("請選擇封面圖", "error", function() {
            _this.dialogVisible = false;
          });
          return false;
        }
        if (_this.VideoUrl.length === 0) {
          _this.dialogVisible = true;
          _this.$propMessage("請選擇影片", "error", function() {
            _this.dialogVisible = false;
          });
          return false;
        }
      }
      if (_this.layout == 4) {
        if (_this.audioFile.length === 0) {
          _this.dialogVisible = true;
          _this.$propMessage("請選擇音頻", "error", function() {
            _this.dialogVisible = false;
          });
          return false;
        }
      }
      if (_this.layout == 5) {
        const title = this.voteList.some(item => item.name.trim() === "");
        if (title) {
          _this.dialogVisible = true;
          _this.$propMessage("請輸入投票选项", "error", function() {
            _this.dialogVisible = false;
          });
          return;
        }
      }
      _this
        .$confirm("是否確認發佈該新聞", "提示信息", {
          confirmButtonText: "確認",
          cancelButtonText: "取消",
          center: true,
          closeOnClickModal: false
        })
        .then(() => {
          // if( this.layout == 3 && this.VideoUrl.length === 1 && this.videoCdnFlag == false){
          //   this.$Mint.Toast({message: '請等待影片完成cdn預熱操作'});
          //   return false
          // }
          // 確認發佈
          let mainImage = "";
          let videoUrl = "";
          let audioUrl = "";
          let voteText = "";
          if (_this.layout == 2) {
            mainImage = _this.mainPictureUrl[0].url;
          } else if (_this.layout == 3) {
            mainImage = _this.titlePictureUrl[0].url;
            videoUrl = _this.VideoUrl[0].url;
          } else if (_this.layout == 4) {
            audioUrl = _this.audioFile[0].url;
          } else if (_this.layout == 5) {
            const checkText = _this.voteContent.trim() === "";
            if (checkText) {
              _this.voteContent = "";
            }
            voteText = `<p>${_this.voteContent}</p>`;
          }
          if (_this.require === true) {
            _this.require = false;

            if (_this.type === "add") {
              let param = {
                title: _this.data.diaryName,
                type: _this.data.diaryType,
                diaryType: Number(_this.layout),
                publishDate: _this.$formatDate(
                  new Date(new Date().getTime() + 2000)
                ),
                primaryPictureUrl: mainImage,
                voteList: _this.voteList,
                vlogUrl: videoUrl,
                audioUrl: audioUrl,
                context: _this.layout == 5 ? voteText : _this.content,
                // oriType: this.userLayout,
                audioDuration: _this.audioDuration,
                autodyneUrls: _this.mainPictureUrl.map(item => {
                  return item.url;
                })
              };

              if (this.timingFlag) {
                param.status = 2;
                param.publishDate = this.$getTime(
                  this.getNewTime(this.publishTime)
                );
              } else {
                param.status = 1;
              }

              _this
                .$post(
                  "/request/diary/addDiary",
                  param,
                  _this.$GLOBAL.jsonConfig
                )
                .then(res => {
                  _this.dialogVisible = true;
                  if (res.code === "00000") {
                    //新增成功提示
                    _this.$propMessage("發佈成功", "success", function() {
                      _this.dialogVisible = false;
                      _this.$router.push("/JJdiary");
                    });
                  } else if (res.code === "40002") {
                    if (res.data === "包含非法字符") {
                      _this.$propMessage(
                        "輸入內容不能包含非法字符，請重試",
                        "error",
                        function() {
                          _this.dialogVisible = false;
                        }
                      );
                    } else {
                      _this.$propMessage(res.message, "error", function() {
                        _this.dialogVisible = false;
                      });
                    }
                  } else {
                    _this.$propMessage(res.message, "error", function() {
                      _this.dialogVisible = false;
                    });
                  }
                });
            } else if (_this.type === "edit") {
              let editParam = {
                id: _this.id,
                title: _this.data.diaryName,
                type: _this.data.diaryType,
                diaryType: Number(this.layout),
                updateDate: _this.originalPublishTime,
                primaryPictureUrl: mainImage,
                vlogUrl: videoUrl,
                context: _this.layout == 5 ? voteText : _this.content,
                voteList: _this.voteList,
                audioUrl: audioUrl,
                audioDuration: _this.audioDuration,
                autodyneUrls: _this.mainPictureUrl.map(item => {
                  return item.url;
                })
              };

              if (this.timingFlag) {
                editParam.status = 2;
                editParam.publishDate = this.$getTime(
                  this.getNewTime(this.publishTime)
                );
              } else {
                editParam.status = 1;
              }

              _this
                .$post(
                  "/request/diary/editDiary",
                  editParam,
                  _this.$GLOBAL.jsonConfig
                )
                .then(res => {
                  _this.dialogVisible = true;
                  if (res.code === "00000") {
                    //新增成功提示
                    _this.$propMessage("修改成功", "success", function() {
                      _this.dialogVisible = false;
                      _this.$router.push("/JJdiary");
                    });
                  } else if (res.code === "40002") {
                    if (res.data === "包含非法字符") {
                      _this.$propMessage(
                        "輸入內容不能包含非法字符，請重試",
                        "error",
                        function() {
                          _this.dialogVisible = false;
                        }
                      );
                    } else {
                      _this.$propMessage(res.message, "error", function() {
                        _this.dialogVisible = false;
                      });
                    }
                  } else {
                    _this.$propMessage(res.message, "error", function() {
                      _this.dialogVisible = false;
                    });
                  }
                });
            }
          }
          setTimeout(() => {
            _this.require = true;
          }, 5000);
        })
        .catch(() => {});
    },
    getNewTime(time) {
      let now = new Date();
      let getTime = new Date(time);
      return now.getTime() > getTime.getTime() ? now : getTime;
    },
    // 实时更新富文本内容
    getContent(data) {
      this.content = data;
    },
    changeTime(val) {
      let time = new Date(val).getTime();
      let now = new Date().getTime();
      if (time < now) {
        this.dialogVisible = true;
        this.$propMessage("請選擇大於當前時間", "error", () => {
          this.dialogVisible = false;
          this.publishTime = "";
        });
      }
    }
  },
  components: {
    Editor,
    DiaMess
  },
  computed: {
    timeAfter() {
      let start = new Date().getTime();
      return {
        disabledDate: time => time.getTime() <= start - 24 * 60 * 60 * 1000
      };
    }
  }
};
</script>

<style lang="less" scoped>
/deep/.el-textarea__inner {
  line-height: 14px !important;
  height: 130px !important;
}

.contentDetails {
  .el-form .el-form-item {
    white-space: normal;
  }

  .detailsContent {
    padding-bottom: 40px;

    @media (max-width: 420px) {
      padding-bottom: 25px;
    }
  }

  .previewMain {
    width: 2rem;
    height: 4.2rem;
    margin: 0 auto;
    position: relative;

    .previewBg {
      width: 100%;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;
    }

    .newsContent {
      width: 100%;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 10;

      .previewTop {
        padding: 0 0.08rem;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin-top: 0.8rem;

        @media (max-width: 420px) {
          padding: 0 0.15rem;
          margin-top: 95px;
        }

        .headWrap {
          position: relative;
          width: 20px;
          height: 20px;
          border-radius: 50%;

          &:after {
            position: absolute;
            content: "";
            top: -8px;
            left: 12px;
            width: 12px;
            height: 12px;
            background-image: url("../assets/images/common/icon_huangguan.png");
            background-size: 100%;
            background-repeat: no-repeat;
          }

          img {
            display: block;
            width: 100%;
            height: 100%;
            border-radius: 50%;
          }
        }

        .infoWrap {
          padding-left: 6px;

          p {
            text-align: left;
          }
        }
      }

      .newsMain {
        width: 1.56rem;
        height: 1.56rem;
        border-radius: 0.1rem;
        margin: 0.06rem 0;
        margin-left: 35px;
        overflow: hidden;
        position: relative;

        @media (max-width: 420px) {
          width: 3.08rem;
          height: 3.08rem;
          border-radius: 0.2rem;
          margin: 0.1rem 0;
          margin-left: 35px;
        }

        .newsMainImg {
          display: block;
          width: 1.56rem;
          height: 1.56rem;
          overflow: hidden;
          position: absolute;
          top: 0;
          left: 0;
          z-index: 20;

          @media (max-width: 420px) {
            width: 3.08rem;
            height: 3.08rem;
          }
        }

        .newsWrap {
          background: linear-gradient(
            bottom,
            rgba(0, 0, 0, 0.5),
            rgba(0, 0, 0, 0)
          );
          position: absolute;
          bottom: 0;
          left: 0;
          z-index: 99;
          width: 100%;
          height: 50%;
          border-radius: 0.1rem;
          padding: 0 0.08rem;
          display: flex;
          align-items: flex-end;

          @media (max-width: 420px) {
            border-radius: 0.2rem;
            padding: 0 0.2rem;
          }

          .vip-icon {
            margin-top: 3px;
            width: 20px;
            height: 10px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-top-left-radius: 0.05rem;
            border-bottom-right-radius: 0.05rem;
            background: -webkit-linear-gradient(
              150deg,
              rgba(190, 162, 117, 1),
              rgba(237, 223, 190, 1)
            ); /* Safari 5.1 - 6.0 */
            background: -o-linear-gradient(
              150deg,
              rgba(190, 162, 117, 1),
              rgba(237, 223, 190, 1)
            ); /* Opera 11.1 - 12.0 */
            background: -moz-linear-gradient(
              150deg,
              rgba(190, 162, 117, 1),
              rgba(237, 223, 190, 1)
            ); /* Firefox 3.6 - 15 */
            background: linear-gradient(
              150deg,
              rgba(190, 162, 117, 1),
              rgba(237, 223, 190, 1)
            ); /* 标准的语法 */

            @media (max-width: 420px) {
              width: 35px;
              height: 10px;
            }

            img {
              width: 80%;

              @media (max-width: 420px) {
                width: 85%;
              }
            }
          }

          .totop {
            width: 0.5rem;
            height: 0.15rem;
            margin-left: 0.08rem;
            font-size: 0.08rem;
            color: #fff;
            border-top-left-radius: 0.05rem;
            border-bottom-right-radius: 0.05rem;
            font-weight: bold;
            font-style: italic;
            background: -webkit-linear-gradient(
              -90deg,
              rgba(171, 96, 255, 1),
              rgba(105, 56, 223, 1)
            ); /* Safari 5.1 - 6.0 */
            background: -o-linear-gradient(
              -90deg,
              rgba(171, 96, 255, 1),
              rgba(105, 56, 223, 1)
            ); /* Opera 11.1 - 12.0 */
            background: -moz-linear-gradient(
              -90deg,
              rgba(171, 96, 255, 1),
              rgba(105, 56, 223, 1)
            ); /* Firefox 3.6 - 15 */
            background: linear-gradient(
              -90deg,
              rgba(171, 96, 255, 1),
              rgba(105, 56, 223, 1)
            );
          }

          .newsText {
            color: #fff;
            font-size: 0.1rem;
            margin-left: 6px;
            line-height: 15px;
            text-align: left;
            width: 86%;

            @media (max-width: 420px) {
              font-size: 12px;
            }
          }
        }

        .interact {
          position: absolute;
          z-index: 99;
          bottom: 0.06rem;
          right: 0;
          padding: 0 0.08rem;
          color: rgba(255, 255, 255, 0.5);
          font-size: 0.1rem;

          @media (max-width: 420px) {
            bottom: 0.1rem;
            padding: 0 0.18rem;
          }
        }
      }
    }
  }

  .mobile_img {
    display: flex;
    justify-content: flex-start;
    padding-bottom: 25px;
  }

  .tips_font {
    font-size: 16px;
    color: #101010;
    padding: 15px 10px;

    @media (max-width: 420px) {
      font-size: 14px;
    }
  }

  .el-input__inner,
  .prop-title {
    color: #666666;
  }

  .btn {
    cursor: pointer;
  }

  //适配手机端
  .mobile_show {
    @media (max-width: 420px) {
      height: 80%;
      top: 45%;
    }
  }

  .previewMain {
    @media (max-width: 420px) {
      width: 60%;
      height: 80%;
    }
  }

  .previewBg {
    @media (max-width: 420px) {
      height: 100%;
    }
  }

  .el-select {
    width: 100%;
  }

  .mobileBtn {
    @media (max-width: 420px) {
      padding-bottom: 0;
      margin-bottom: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/JJdiary.vue